import Fade from "./Fade.react"
import Fun from "./Fun.react"

const content = { Fade, Fun }
export default content
